export default __webpack_public_path__ + "static/media/mobility_simulation_icon.5f3a7906.svg";